'use strict';
var constants = require('./constants');
var removePanels = require('./util/remove-panels');
var getDomain = require('./util/domain');

function _setTransparentIframe(iframe) {
    iframe.frameBorder = '0';
    iframe.border = '0';
    iframe.scrolling = 'no';
    iframe.allowTransparency = 'true';
    return iframe;
}

function _buildDiv(className, id) {
    var div = document.createElement('div');
    if (className) {
        div.className = className;
    }
    if (id) {
        div.id = id;
    }
    return div;
}

function _buildLightbox(config) {
    var UI = {};

    UI.wrapper = _buildDiv(null, config.name);

    UI.panel = _buildDiv('PPIC-panel PPIC-lightbox animated', 'PPPanel');

    // workaround: IE6 + 7 won't let you name an iframe after you create it
    try {
        UI.iframe = document.createElement('<iframe name="' + config.name + '" id="' + config.name + 'frame' + '" role="dialog">');
    } catch (e) {
        UI.iframe = document.createElement('iframe');
        UI.iframe.name = config.name;
        UI.iframe.id = config.name + 'frame';
        UI.iframe.setAttribute('role', 'dialog');
    }

    _setTransparentIframe(UI.iframe);

    UI.mask = _buildDiv('PP-IC-mask');

    UI.loading = _buildDiv('modal');

    var logo = _buildDiv('logo');
    UI.loading.appendChild(logo);

    UI.loading.className = UI.loading.className + ' loading';
    // var loadingSpinner = document.createElement('div');
    // loadingSpinner.className = 'spinner';
    // UI.loading.appendChild(loadingSpinner);

    UI.panel.appendChild(UI.iframe);
    UI.wrapper.appendChild(UI.mask);
    UI.wrapper.appendChild(UI.loading);
    UI.wrapper.appendChild(UI.panel);

    document.body.className = document.body.className + ' ' + config.name;
    document.body.appendChild(UI.wrapper);

    return UI;
}



function _determineLightboxEnabled(config) {
    var domain = getDomain(config);
    var url = domain + constants.ONETOUCH_CONTEXT_ROOT + '?guid=' + config.frameGuid + (config.debug ? '&incontext_iframe=1' : '');
    var xhr = new XMLHttpRequest();

    // IE9 can use XDomainRequest as a fallback for no CORS support
    if (!('withCredentials' in xhr) && typeof XDomainRequest !== 'undefined') {
        xhr = new XDomainRequest();
    }

    // If XHR w/ CORS is supported...
    if (xhr && 'withCredentials' in xhr) {
        try {
            xhr.withCredentials = true;
            // set a timeout on this to prevent super long loads
            xhr.timeout = constants.LOADING_TIMEOUT;

            xhr.open('GET', url);

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var response = JSON.parse(xhr.responseText);
                    var remembered = response && response.data && response.data.remembered;

                    if (remembered) {
                        config.oneTouchEnabled = true;
                    }
                }
            };

            xhr.onerror = function () {
                config.oneTouchEnabled = false;
            };

            xhr.send();
        } catch (err) {
            config.oneTouchEnabled = false;
        }
    }
}



/**
 * Hides lightbox when user clicks Esc key.
 */
function _toggleLightbox(callback) {
    return function (event) {
        if (event.which === null && (event.charCode !== null || event.keyCode !== null)) {
            event.which = event.charCode !== null ? event.charCode : event.keyCode;
        }
        if (event.which === 27) {
            // errMsg = constants.ERROR_MESSAGES.BUYER_CANCELLED_TRANSACTION;
            callback();
        }
    };
}

function _destroyLightbox(app, config, callback) {
    app.lightbox.panel.className += ' bounceOutDown';

    setTimeout(function () {
        removePanels(config);

        app.lightbox.wrapper.className = '';

        config.oneTouchEnabled = false;

        if (callback) {
            callback();
        }
    }, 700);
}

function isLightboxEnabled(config) {
    var oneTouchEnabled = config.oneTouchEnabled; // If a user is one touch enabled, or fully logged in...
    var thirdPartyCookiesEnabled = config.thirdPartyCookiesEnabled; // If a browser has third party cookies enabled...
    var forceLightboxDisabled = config.forceLightboxDisabled; // If a merchant forces the lightbox to be disabled (undocumented)...
    var isNotIE = !config.needsIframeBridge; // IE may break lightbox

    return oneTouchEnabled && thirdPartyCookiesEnabled && !forceLightboxDisabled && isNotIE;
}

var Lightbox = {
    build: _buildLightbox,
    destroy: _destroyLightbox,
    toggle: _toggleLightbox,
    isEligible: _determineLightboxEnabled,
    isEnabled: isLightboxEnabled
};

module.exports = Lightbox;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lightbox.js
 ** module id = 19
 ** module chunks = 0
 **/